import { grey, red } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'
export * from '@carsys/ui/src/Theme/types/mui-theme'

// Default CarSys Theme

export const SupportTheme = createTheme({
  palette: {
    primary: { main: 'rgb(8, 92, 240)' },
    secondary: { main: '#454545', contrastText: '#83b6de' },
    success: { main: '#4caf50', dark: '#388e3c' },
    error: { main: '#d32f2f', dark: '#c3161c' },
    warning: { main: '#f57c00', dark: '#f2711c' },
    muted: {
      main: grey[400],
      dark: grey[600],
      light: grey[400],
      contrastText: '#333',
      backgroundHighlight: grey[200]
    },
    LKQGrey: {
      background: { modest: grey[600], highlight: grey[700], surface: grey[100], surfaceHover: grey[50] },
      border: { modest: 'rgba(0, 0, 0, 0.12)' }
    },
    primaryThemeColor: {
      main: 'rgb(8, 92, 240)',
      light: 'rgb(66, 135, 255)',
      dark: 'rgb(0, 31, 84)',
      extraDark: 'rgb(0 19 53)',
      contrastText: '#fff'
    }
  },
  components: {
    // default props have changed in mui v5, so set it back to the old default
    MuiTextField: {
      defaultProps: {
        variant: 'outlined'
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'outlined'
      }
    },
    MuiSelect: {
      defaultProps: {
        variant: 'outlined'
      }
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: red[500],
          '&$error': {
            color: red[500]
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          // extend color="muted" buttons to still show visible text
          if (ownerState.color === 'muted') {
            return {
              color: theme.palette.muted.contrastText,
              backgroundColor: '#fff',
              '&:hover': { backgroundColor: theme.palette.muted.backgroundHighlight }
            }
          }
          return {}
        }
      }
    }
  }
})
